import * as React from "react";
import { cn } from "@/lib/utils";

interface TableHeaderProps
    extends React.HTMLAttributes<HTMLTableSectionElement> {
    /** When false, disables the default pl-8/pr-8 on the first/last header cell. Defaults to true. */
    applyEdgePadding?: boolean;
}

const TableHeader = React.forwardRef<HTMLTableSectionElement, TableHeaderProps>(
    ({ applyEdgePadding = true, className, ...props }, ref) => (
        <thead
            ref={ref}
            className={cn(
                "bg-table-header border-b border-table-border [&_tr]:border-b [&_tr]:border-table-border [&_tr]:bg-transparent [&_tr]:hover:bg-transparent",
                applyEdgePadding &&
                    "[&_tr>th:first-child]:pl-8 [&_tr>th:last-child]:pr-8",
                className,
            )}
            {...props}
        />
    ),
);
TableHeader.displayName = "TableHeader";

export { TableHeader };
export type { TableHeaderProps };
